import { render, staticRenderFns } from "./AnotherPassengerMainNightCard.vue?vue&type=template&id=65b5c336"
import script from "./AnotherPassengerMainNightCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnotherPassengerMainNightCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports